import { Component, OnInit, Inject, Optional, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ProfileService } from '../../../../services/profile.service';
import { NbGlobalPosition, NbGlobalPhysicalPosition, NbToastrService, NbComponentStatus } from '@nebular/theme';
import { FollowStepsDialogComponent } from '../../../popups/follow-steps-dialog/follow-steps-dialog.component';
import { forkJoin } from 'rxjs';
import { patterns } from '../../../../../assets/patterns';

@Component({
  selector: 'invite-user',
  templateUrl: './invite-user.component.html',
  styleUrls: ['./invite-user.component.scss']
})
export class InviteUserComponent implements OnInit {

  formInviteUser: UntypedFormGroup;
  loading: boolean = false;
  mobileError: number = 0;
  RoleDescription: any;
  arrYesNo = ['No', 'Yes'];
  userHierachy = [
    { key: 'CH1', value: 'Corporate' },
    { key: 'CH2', value: 'Region' },
    { key: 'CH3', value: 'Division' },
    { key: 'CH4', value: 'Location' },
  ];
  errorMsgEmail: string;
  errorMsgPhone: string;
  errorId: number = 0;
  preventDuplicates = false;
  position: NbGlobalPosition = NbGlobalPhysicalPosition.TOP_RIGHT;
  statusSuccess: 'success';
  statusFailure: 'warning';
  destroyByClick = true;
  duration = 5000;
  hasIcon = true;
  Roles: any;
  userHierachyAssociation: any;
  CompanyRoleDescription: any;
  CompanyRole: any;
  selectedHierarchy = '';
  arrPriorities: any;
  bubbleHierarchy: any;
  bubbleCustomerKey: any;
  onInviteUser = new EventEmitter();
  isApprover: boolean = false;
  showApproverFields: boolean = false;
  showPriority: boolean = false;
  errorMsgUserAssociation: string;
  errorMsgCompanyRole: string;
  errorAssociation: boolean;
  errorCompanyRole: boolean;

  constructor(
    public dialogRef: MatDialogRef<InviteUserComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private profileService: ProfileService,
    private formBuilder: UntypedFormBuilder,
    private toastrService: NbToastrService,
    private dialog: MatDialog
  ) {
    dialogRef.disableClose = true;
  }

  isBubbleCall: boolean = false;
  ngOnInit() {
    this.formInviteUser = this.formBuilder.group({
      inviteUserFName: ['', Validators.required],
      inviteUserLName: ['', Validators.required],
      inviteUserHierarchy: ['', Validators.required],
      userAssociation: ['', Validators.required],
      inviteUserCompanyRole: [''],
      inviteUserPriority: [''],
      inviteUserView: ['', Validators.required],
      repairLimit: [''],
      tireLimit: [''],
      inviteUserEmail: ['', [Validators.required, Validators.pattern(patterns.emailPattern)]],
      inviteUserPhone: ['', Validators.pattern(patterns.mobNumPattern)],
    });

    const roleRequest = this.profileService.getCustomerUserRoleType();
    const companyRoleRequest = this.profileService.getCompanyRoleCustomized(sessionStorage.getItem('legacyCustomerKeyId'));
    this.loading = true;
    forkJoin([roleRequest, companyRoleRequest]).subscribe(result => {
      this.loading = false;
      this.RoleDescription = result[0];
      this.Roles = result[0];
      this.CompanyRoleDescription = result[1];
      if (this.data.isBubbleCall == 1) {
        this.isBubbleCall = true;
        this.bubbleHierarchy = this.data.hierarchyData.hierarchy;
        this.bubbleCustomerKey = this.data.hierarchyData.customerKey;
        this.formInviteUser.get('inviteUserHierarchy').setValue(this.data.hierarchyData.hierarchy);
        this.formInviteUser.get('userAssociation').setValue(this.data.hierarchyData.customerKey);
        const value = this.userHierachy.find(element => element.value === this.bubbleHierarchy);
        this.setInviteUserData(this.bubbleHierarchy, value.key);
      }
    });

    this.arrPriorities = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    switch (sessionStorage.getItem('hierachy').toString()) {
      case 'Region': {
        this.userHierachy = this.userHierachy.slice(1);
        break;
      }
      case 'Division': {
        this.userHierachy = this.userHierachy.slice(2);
        break;
      }
      case 'Location': {
        this.userHierachy = this.userHierachy.slice(3);
        break;
      }
    }

    this.formInviteUser.get('userAssociation').disable();
    this.formInviteUser.get('inviteUserView').disable();
    this.formInviteUser.get('inviteUserCompanyRole').disable();
    this.formInviteUser.get('repairLimit').disable();
    this.formInviteUser.get('tireLimit').disable();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  getApprovalLimit(e) {
    this.loading = true;
    this.formInviteUser.get('repairLimit').disable();
    this.formInviteUser.get('tireLimit').disable();
    this.profileService.getApprovalLimit(e.value).subscribe(response => {
      this.loading = false;
      let floatRepairLimit = response[0].RepairLimit;
      let intTireLimit = response[0].TireLimit;
      this.formInviteUser.controls.repairLimit.setValue(floatRepairLimit);
      this.formInviteUser.controls.tireLimit.setValue(intTireLimit);
      if (this.formInviteUser.get('inviteUserHierarchy').value === 'Corporate' || this.formInviteUser.get('inviteUserHierarchy').value === 'Region') {
        this.formInviteUser.get('repairLimit').enable();
        this.formInviteUser.get('tireLimit').enable();
      }
    });
  }

  InviteNewUser() {
    if (this.mobileError == 1)
      return false;

    this.loading = true;
    const userDetails = this.formInviteUser.value;
    userDetails.customerId = sessionStorage.getItem('customerUserInformationId');
    userDetails.companyName = sessionStorage.getItem('companyName');
    userDetails.companyEmail = JSON.parse(sessionStorage.getItem('userDetails')).email;
    userDetails.companyBillingEmail = JSON.parse(sessionStorage.getItem('userDetails')).billingEmail;
    userDetails.inviteUserAddress = JSON.parse(sessionStorage.getItem('userDetails')).address;
    userDetails.inviteUserCity = JSON.parse(sessionStorage.getItem('userDetails')).city;
    userDetails.inviteUserState = JSON.parse(sessionStorage.getItem('userDetails')).state;
    userDetails.inviteUserZip = JSON.parse(sessionStorage.getItem('userDetails')).zip;
    userDetails.priority = this.formInviteUser.get('inviteUserPriority').value;
    userDetails.repairLimit = this.formInviteUser.get('repairLimit').value;
    userDetails.tireLimit = this.formInviteUser.get('tireLimit').value;
    userDetails.inviteUserView = this.formInviteUser.get('inviteUserView').value;
    userDetails.inviteUserRole = this.formInviteUser.get('inviteUserCompanyRole').value;
    userDetails.customerParentInformationId = sessionStorage.getItem('customerParentInformationID');
    userDetails.subScriptionType = sessionStorage.getItem('subscriptionType') != 'null' ? sessionStorage.getItem('subscriptionType') : '';
    userDetails.agreementTemplateURL = sessionStorage.getItem('agreementURL');
    userDetails.resendEmail = false;

    this.profileService.InviteNewUser(userDetails).subscribe(response => {
      this.loading = false;
      if (response.id == 101) {
        this.loading = false;
        this.errorId = 101;
        this.errorMsgEmail = 'Email Id already exist!';
        //this.errorMsgPhone = 'Mobile Number already exist!';
      } else if (response.id == 102) {
        this.loading = false;
        this.errorId = 102;
        this.errorMsgEmail = 'Email Id already exist!';
      } else if (response.id == 103) {
        this.loading = false;
        this.errorId = 103;
        this.errorMsgPhone = 'Mobile Number already exist!';
      } else if (response.status) {
        let msg = 'Invitation Sent successfully.!';
        this.onInviteUser.emit();
        this.showToast(this.statusSuccess, this.position, msg);
        this.loading = false;
        this.dialogRef.close();
      } else {
        let msg = 'Failed to Sent Invitation.!'
        this.showToast(this.statusFailure, this.position, msg);
        this.loading = false;
      }
    });
  }

  getlength(event) {
    this.mobileError = 0;
    this.errorId = 0;
    let number = event.target.value;
    number = number.toString();
    let mobileNumber = number.replace(/[-()]/g, '');
    let moblength = mobileNumber.length;
    if (moblength > 10) {
      this.mobileError = 1;
    }
  }

  removeError() {
    this.errorId = 0;
  }

  showLocation(event) {
    this.errorAssociation = false;
    this.errorCompanyRole = false;
    this.formInviteUser.get('inviteUserCompanyRole').setValue('');
    this.formInviteUser.get('userAssociation').setValue('');
    this.formInviteUser.get('inviteUserView').setValue('');
    let value = event.source.selected._element.nativeElement.getAttribute('view').toString();
    this.setInviteUserData(event.value, value);
  }

  setInviteUserData(hierachyLevel, value) {
    this.formInviteUser.get('inviteUserCompanyRole').enable();
    this.formInviteUser.get('userAssociation').enable();
    this.formInviteUser.get('inviteUserView').enable();
    this.selectedHierarchy = hierachyLevel;
    const arrHierarchyLevels = [];
    let intLevel = value[value.length - 1];
    for (let i = 1; i <= intLevel; i++) {
      arrHierarchyLevels.push('CH' + i);
    }
    this.Roles = this.RoleDescription.filter((item) => arrHierarchyLevels.includes(item.userLevel));
    this.Roles = this.sortByKkey(this.Roles, 'userRoleGroupName');
    this.CompanyRole = this.CompanyRoleDescription.filter((item) => item.hierarchy == hierachyLevel);
    this.userHierachyAssociation = [];
    let hierarchyLevel = sessionStorage.getItem('hierachy').toString();

    if (this.selectedHierarchy === 'Corporate' || this.selectedHierarchy === 'Region') {
      this.showApproverFields = true;
      this.showPriority = false;
      this.formInviteUser.get('inviteUserPriority').setValidators(null);
    } else {
      this.showApproverFields = false;
      this.showPriority = true;
      this.formInviteUser.get('inviteUserPriority').setValidators(Validators.required);
    }
    this.formInviteUser.get('inviteUserPriority').updateValueAndValidity();

    if (intLevel == 1 && hierarchyLevel === 'Corporate' ||
      intLevel == 2 && hierarchyLevel === 'Region' ||
      intLevel == 3 && hierarchyLevel === 'Division' ||
      intLevel == 4 && hierarchyLevel === 'Location'
    ) {

      var strCustomerName = sessionStorage.getItem('companyName');
      if (hierarchyLevel === 'Region') {
        var strCustomerName = sessionStorage.getItem('loggedInRegionName');
      } else if (hierarchyLevel === 'Division') {
        var strCustomerName = sessionStorage.getItem('loggedInDivisionName');
      } else if (hierarchyLevel === 'Location') {
        var strCustomerName = sessionStorage.getItem('loggedInLocationName');
      }

      this.userHierachyAssociation = [{
        customerKey: sessionStorage.getItem('userAssociation').toString() == '0' ? sessionStorage.getItem('legacyCustomerKeyId') : sessionStorage.getItem('userAssociation'),
        customerName: strCustomerName
      }];

      if (this.formInviteUser.get('userAssociation').value === '') {
        this.formInviteUser.get('userAssociation').setValue(sessionStorage.getItem('userAssociation').toString() == '0' ? sessionStorage.getItem('legacyCustomerKeyId') : sessionStorage.getItem('userAssociation'));
      }

      if (this.CompanyRole.length <= 0) {
        this.openFollowStepsDialog();
      }
      return;
    }

    switch (sessionStorage.getItem('hierachy').toString()) {
      case 'Corporate': {
        const data = {
          'userInformationId': sessionStorage.getItem('customerParentInformationID'),
          'customerKey': sessionStorage.getItem('legacyCustomerKeyId'),
          'userHierarchy': hierachyLevel
        }
        this.loading = true;
        this.profileService.getCorporateUserInviteList(data).subscribe(resCustomerHierarchyRegion => {
          this.userHierachyAssociation = resCustomerHierarchyRegion;
          this.loading = false;
          this.openFollowStepsDialog();
        });
        break;
      }
      case 'Region': {
        const data = {
          'userInformationId': sessionStorage.getItem('customerParentInformationID'),
          'regionId': sessionStorage.getItem('userAssociation'),
          'userHierarchy': hierachyLevel
        }
        this.loading = true;
        this.profileService.getRegionUserInviteList(data).subscribe(resCustomerHierarchyRegion => {
          this.userHierachyAssociation = resCustomerHierarchyRegion;
          this.loading = false;
          this.openFollowStepsDialog();
        });
        break;
      }
      case 'Division': {
        const data = {
          'userInformationId': sessionStorage.getItem('customerParentInformationID'),
          'divisionId': sessionStorage.getItem('userAssociation')
        }
        this.loading = true;
        this.profileService.getDivisionUserInviteList(data).subscribe(resCustomerHierarchyRegion => {
          this.userHierachyAssociation = resCustomerHierarchyRegion;
          this.loading = false;
          this.openFollowStepsDialog();
        });
        break;
      }
    }

    if (this.data.isBubbleCall == 1) {
      this.formInviteUser.get('userAssociation').setValue(this.bubbleCustomerKey.toString());
    }
  }

  sortByKkey(array, key) {
    return array.sort(function (a, b) {
      var x = a[key]; var y = b[key];
      return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
  }

  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: this.destroyByClick,
      duration: this.duration,
      hasIcon: this.hasIcon,
      position: this.position,
      preventDuplicates: this.preventDuplicates,
    };
    this.toastrService.show(
      body,
      '',
      config);
  }

  openFollowStepsDialog(): void {
    this.errorAssociation = false;
    this.errorCompanyRole = false;
    // if (this.userHierachyAssociation.length <= 0) {
    //   this.errorMsgUserAssociation = 'Please load hierarchy for ' + this.selectedHierarchy + ' by navigating Hierarchy.';
    //   this.errorAssociation = true;
    // }
    // if (this.CompanyRole.length <= 0) {
    //   this.errorMsgCompanyRole = 'Please add Company Roles for ' + this.selectedHierarchy + ' by navigating Limits & Approvals.';
    //   this.errorCompanyRole = true;
    // }
  }

}

